import React, { useEffect, useState } from 'react';
import HeaderDashboard from 'Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { HttpService } from 'library';
import Sidebar from 'Components/DashboardComponent/sidebar/Sidebar';
import { toast } from 'react-toastify';
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxisItem,
    ChartTitle,
    ChartLegend,
    ChartValueAxis,
    ChartAxisDefaults,
} from "@progress/kendo-react-charts";
import Hammer from 'hammerjs';
import { IoFilter } from 'react-icons/io5';
import { SystemPopup, SystemGrid, SystemPanel } from 'library';
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import { Form, Input, EditModes, LookUpDropDown, DropDown, Switch } from 'library';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import OpportunityChartDetail from 'Components/Opportunities/OpportunityChartDetail'

const OpportunityChart = () => {
    const [filter, setFilter] = useState(false);
    const [strategicPartner, setStrategicPartner] = useState('');
    const [incumbent, setIncumbent] = useState('');
    const [dataLoader, setDataLoader] = useState(false);
    const [dataResults, setDataResults] = useState([]);

    const [locationsList, setLocationsList] = useState([]);
    const [NAICSList, setNAICSList] = useState([]);
    const [agencyList, setAgencyList] = useState([]);
    const [workflowStageList, setWorkflowStageList] = useState([]);
    const [opportunityStatusList, setOpportunityStatusList] = useState([]);

    const [filterOne, setFilterOne] = useState(true);
    const [filterTwo, setFilterTwo] = useState(true);
    const [filterThree, setFilterThree] = useState(true);
    const [filterFour, setFilterFour] = useState(true);
    const [filterFive, setFilterFive] = useState(true);

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedNAICSs, setSelectedNAICSs] = useState([]);
    const [selectedAgencies, setSelectedAgencies] = useState([]);
    const [selectedWorkflowStages, setSelectedWorkflowStages] = useState([]);
    const [selectedOpportunityStatuses, setSelectedOpportunityStatuses] = useState([]);

    const [annualContractValueData, setAnnualContractValueData] = useState([]);
    const [winsByBDOfficeData, setWinsByBDOfficeData] = useState([]);
    const [categoriesForContractPriceToWin, setCategoriesForContractPriceToWin] = useState([]);
    const [contractValueVsPriceToWinData, setContractValueVsPriceToWinData] = useState([]);
    const [categoriesForWins, setCategoriesForWins] = useState([]);
    const [activeOpportunitiesData, setActiveOpportunitiesData] = useState([]);
    const [contractValueBDOfficeData, setContractValueBDOfficeData] = useState([]);
    const [contractValueNAICSData, setContractValueNAICSData] = useState([]);
    const [contractValueAgencyData, setContractValueAgencyData] = useState([]);
    const [totalExpenseBudgetData, setTotalExpenseBudgetData] = useState([]);
    const [opportunitiesByStatusData, setOpportunitiesByStatusData] = useState([]);
    const [proposalsDueData, setproposalsDueData] = useState([]);
    const [categoriesProposalsDue, setCategoriesProposalsDue] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [office, setOffice] = useState('');
    const [chartTitle, setChartTitle] = useState('');
    const [popupTitle, setpopupTitle] = useState(chartTitle + '-' + office);
    const [xAxis, setxAxis] = useState('');
    const [yAxis, setyAxis] = useState('');

    useEffect(() => {
        let title = office ? chartTitle + ' - ' + office : chartTitle;
        setpopupTitle(title);
    }, [chartTitle, office])

    ///**
    //* @author:Sanju Bishnoi
    //* @description: format currency for the amount.
    //*/
    //const formatter = new Intl.NumberFormat('en-US', {
    //    style: 'currency',
    //    currency: 'USD',
    //    minimumFractionDigits: 2,
    //});

    const allLocation = (value) => {
        var locationList = document.querySelectorAll('.location_check_boxes input[type=checkbox]')
        const location = [];
        if (value == true) {
            locationList.forEach(x => x.checked = true);
            for (let i = 0; i < locationList.length > 0; i++) {
                if (locationList[i].value != "on") {
                    location.push(locationList[i].value);
                    setSelectedLocations(location);
                }
            }
        } else {
            setSelectedLocations([]);
            locationList.forEach(x => x.checked = false);
        }
    }

    const allNAICS = (value) => {
        var naicsList = document.querySelectorAll('.naics_check_boxes input[type=checkbox]')
        const naics = [];
        if (value == true) {
            naicsList.forEach(x => x.checked = true);
            for (let i = 0; i < naicsList.length > 0; i++) {
                if (naicsList[i].value != "on") {
                    naics.push(naicsList[i].value);
                    setSelectedNAICSs(naics);
                }
            }
        } else {
            setSelectedNAICSs([]);
            naicsList.forEach(x => x.checked = false);
        }
    }

    const allAgency = (value) => {
        var agencyList = document.querySelectorAll('.agency_check_boxes input[type=checkbox]')
        const agency = [];
        if (value == true) {
            agencyList.forEach(x => x.checked = true);
            for (let i = 0; i < agencyList.length > 0; i++) {
                if (agencyList[i].value != "on") {
                    agency.push(agencyList[i].value);
                    setSelectedAgencies(agency);
                }
            }
        } else {
            setSelectedAgencies([]);
            agencyList.forEach(x => x.checked = false);
        }
    }

    const allWorkflowStatus = (value) => {
        var workflowStatusList = document.querySelectorAll('.workflowstatus_check_boxes input[type=checkbox]')
        const workflowStatus = [];
        if (value == true) {
            workflowStatusList.forEach(x => x.checked = true);
            for (let i = 0; i < workflowStatusList.length > 0; i++) {
                if (workflowStatusList[i].value != "on") {
                    workflowStatus.push(workflowStatusList[i].value);
                    setSelectedWorkflowStages(workflowStatus);
                }
            }
        } else {
            setSelectedWorkflowStages([]);
            workflowStatusList.forEach(x => x.checked = false);
        }
    }

    const allOpportunityStatus = (value) => {
        var opportunityStatusList = document.querySelectorAll('.opportunitystatus_check_boxes input[type=checkbox]')
        const opportunityStatus = [];
        if (value == true) {
            opportunityStatusList.forEach(x => x.checked = true);
            for (let i = 0; i < opportunityStatusList.length > 0; i++) {
                if (opportunityStatusList[i].value != "on") {
                    opportunityStatus.push(opportunityStatusList[i].value);
                    setSelectedOpportunityStatuses(opportunityStatus);
                }
            }
        } else {
            setSelectedOpportunityStatuses([]);
            opportunityStatusList.forEach(x => x.checked = false);
        }
    }

    const handleChange = (e) => {
        if (e.target.name.includes('location')) {
            if (e.target.checked) {
                const location = selectedLocations.slice();
                location.push(e.target.value);
                setSelectedLocations(location);
            } else {
                const location = selectedLocations.filter((t) => t !== e.target.value);
                setSelectedLocations(location);
            }
        } else if (e.target.name.includes('naics')) {
            if (e.target.checked) {
                const naics = selectedNAICSs.slice();
                naics.push(e.target.value);
                setSelectedNAICSs(naics);
            } else {
                const naics = selectedNAICSs.filter((t) => t !== e.target.value);
                setSelectedNAICSs(naics);
            }
        } else if (e.target.name.includes('agency')) {
            if (e.target.checked) {
                const agency = selectedAgencies.slice();
                agency.push(e.target.value);
                setSelectedAgencies(agency);
            } else {
                const agency = selectedAgencies.filter((t) => t !== e.target.value);
                setSelectedAgencies(agency);
            }
        } else if (e.target.name.includes('workflowstatus')) {
            if (e.target.checked) {
                const workflowStatus = selectedWorkflowStages.slice();
                workflowStatus.push(e.target.value);
                setSelectedWorkflowStages(workflowStatus);
            } else {
                const workflowStatus = selectedWorkflowStages.filter((t) => t !== e.target.value);
                setSelectedWorkflowStages(workflowStatus);
            }
        } else if (e.target.name.includes('opportunitystatus')) {
            if (e.target.checked) {
                const opportunityStatus = selectedOpportunityStatuses.slice();
                opportunityStatus.push(e.target.value);
                setSelectedOpportunityStatuses(opportunityStatus);
            } else {
                const opportunityStatus = selectedOpportunityStatuses.filter((t) => t !== e.target.value);
                setSelectedOpportunityStatuses(opportunityStatus);
            }
        }
    }

    useEffect(() => {
        const filterListUrl = '/Opportunity/OpportunityChartFilterList';
        const response = HttpService.get(filterListUrl);

        response.then((data) => {
            let locationData = data.data.Data.filter(item => item.LookupName === "BDOffice");
            setLocationsList(locationData);
            allLocation(true);
            let NAICSData = data.data.Data.filter(item => item.LookupName === "NAICS");
            setNAICSList(NAICSData);
            allNAICS(true);
            let agencyData = data.data.Data.filter(item => item.LookupName === "Agency");
            setAgencyList(agencyData);
            allAgency(true);
            let workflowStatusData = data.data.Data.filter(item => item.LookupName === "WorkflowStatus");
            setWorkflowStageList(workflowStatusData);
            allWorkflowStatus(true);
            let opportunityStatusData = data.data.Data.filter(item => item.LookupName === "OpportunityStatus");
            setOpportunityStatusList(opportunityStatusData);
            allOpportunityStatus(true);
        })

        getGraphData();
    }, [1000])

    const getGraphData = async () => {
        const Entity = new FormData();
        Entity.append('StrategicPartner', strategicPartner ? strategicPartner : null);
        Entity.append('Incumbent', incumbent ? incumbent : null);
        Entity.append('Locations', selectedLocations.length != 0 ? selectedLocations.sort() : null);
        Entity.append('NAICSs', selectedNAICSs.length != 0 ? selectedNAICSs.sort() : null);
        Entity.append('Agencies', selectedAgencies != 0 ? selectedAgencies.sort() : null);
        Entity.append('WorkflowStages', selectedWorkflowStages != 0 ? selectedWorkflowStages.sort() : null);
        Entity.append('OpportunityStatues', selectedOpportunityStatuses != 0 ? selectedOpportunityStatuses.sort() : null);
        setDataResults([]);
        await HttpService.post("/Opportunity/OpportunityGraphData/", Entity).then((response) => {
            setDataResults(response.data);
        }).catch(function (error) {
            setDataResults([]);
        });
    }

    useEffect(() => {
        if (Object.keys(dataResults).length > 0) {
            fetchData();
        }
    }, [dataResults]);

    const fetchData = async () => {
        try {
            // Set chart data for the number of wins by BD Office
            const winsByBDOffice = dataResults.WinsByBDOffice;
            setWinsByBDOfficeData(winsByBDOffice);

            // Categories for wins by BD Office
            const valuesArray = winsByBDOffice.map(item => item.Name);
            setCategoriesForWins(valuesArray);

            // Set chart data for the total number of Active Opportunities
            const activeOpportunities = dataResults.NumberOfActiveOpportunities;
            setActiveOpportunitiesData(activeOpportunities);

            // Set chart data for the total contract value by BD Office
            const contractValueByBDOffice = dataResults.TotalContractValueByBDOffice;
            setContractValueBDOfficeData(contractValueByBDOffice);

            // Set chart data for the total contract value by NAICS
            const contractValueByNAICS = dataResults.TotalContractValueByNAICS;
            setContractValueNAICSData(contractValueByNAICS);

            // Set chart data for the total contract value by Agency
            const contractValueByAgency = dataResults.TotalContractValueByAgency;
            setContractValueAgencyData(contractValueByAgency);

            // Set chart data for the total expense budget by BD Office
            const expenseBudgetByBDOffice = dataResults.TotalExpenseBudgetByBDOffice;
            setTotalExpenseBudgetData(expenseBudgetByBDOffice);

            // Set chart data for the number of opportunities by status
            const opportunitiesByStatus = dataResults.OpportunitiesByStatus;
            setOpportunitiesByStatusData(opportunitiesByStatus);

            // Set chart data for the proposals due by month
            const proposalsDueByMonth = dataResults.ProposalsDueByMonth;
            prepareChartData(proposalsDueByMonth);

            // Set chart data for the total accumulated annual contract value by BD office
            const groupedData = {};
            dataResults.AnnualContractValueByBDOffice.forEach(item => {
                const name = item.Name;

                if (!groupedData[name]) {
                    groupedData[name] = {
                        Office: name,
                        data: []
                    };
                }
                groupedData[name].data.push([item.Year, item.Value]);
            });

            // Convert the groupedData object to an array
            const result = Object.values(groupedData);
            setAnnualContractValueData(result);

            // Set chart data for contract value vs price to win                          
            const contractValueVsPriceToWin = [
                {
                    name: 'Contract Value',
                    data: dataResults.ContractValueVsPriceToWin.map(item => item.Value)
                },
                {
                    name: 'Price To Win',
                    data: dataResults.ContractValueVsPriceToWin.map(item => item.Value2)
                }
            ];

            setContractValueVsPriceToWinData(contractValueVsPriceToWin);
            // Categories for contract value vs price to win
            const categoriesForCVvsPTW = dataResults.ContractValueVsPriceToWin.map(item => item.Name);
            setCategoriesForContractPriceToWin(categoriesForCVvsPTW);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const prepareChartData = (data) => {
        const monthMap = {};
        const currentYear = new Date().getFullYear();

        const filteredData = data.filter(proposal => {
            const year = parseInt(proposal.month.split('-')[0], 10);
            return year === currentYear;
        });

        filteredData.forEach(({ Name, month, Value }) => {
            if (!monthMap[month]) {
                monthMap[month] = { month, data: [] };
            }
            monthMap[month].data.push({ Name, Value });
        });

        const categories = Object.keys(monthMap);
        const seriesData = [];

        // Prepare series data for each unique Name
        const uniqueNames = [...new Set(data.map(item => item.Name))];
        uniqueNames.forEach(name => {
            const values = categories.map(month => {
                const monthData = monthMap[month].data.find(d => d.Name === name);
                return monthData ? monthData.Value : 0; // Default to 0 if no data for that month
            });
            seriesData.push({ Name: name, Value: values });
        });
        setCategoriesProposalsDue(categories);
        setproposalsDueData(seriesData);
    };

    //const formValidator = () => {
    //    var errorMsgs = [];
    //    if ((strategicPartner == '' || strategicPartner == null)
    //        && (incumbent == '' || incumbent == null)
    //        && (selectedLocations.length == 0)
    //        && (selectedNAICSs.length == 0)
    //        && (selectedAgencies.length == 0)
    //        && (selectedWorkflowStages.length == 0)
    //        && (selectedOpportunityStatuses.length == 0)) {
    //        toast.error("Please select strategic partner or incumbent. Also check the other filters.");
    //        return false;
    //    }
    //    return true;
    //}

    const handleOnChartValueClick = (chartData, chartName) => {
        let title = chartName.replace('#', 'Number');
        setChartTitle(title);
        if (chartName == 'Total Accumulated Annual Contract Value by BD Office') {
            let bdOffice = chartData.series.name;
            setOffice(bdOffice);
            setxAxis(chartData.dataItem[0]);
            setyAxis(chartData.dataItem[1]);
        }
        else if (chartName == "# of Wins by BD Office") {
            setOffice(chartData.category);
            setxAxis(chartData.category);
            setyAxis(chartData.dataItem);
        }
        else if (chartName == "Total # of Active Opportunities" || chartName == "Total Contract Value by BD Office" || chartName == "Total Contract Value by NAICS" || chartName == "Total Contract Value by Agency" || chartName == 'Total Expense Budget by BD Office' || chartName == 'Number of Opportunities by Status') {
            setOffice(chartData.category);
            setxAxis(chartData.category);
            setyAxis(chartData.dataItem.Value);
        }
        else if (chartName == 'Proposals Due by Month') {
            let bdOffice = chartData.series.name;
            setOffice(bdOffice);
            setxAxis(chartData.category);
            setyAxis(bdOffice);
        }
        else if (chartName == 'Contract Value vs Price to Win') {
            setxAxis(chartData.category);
            setyAxis(chartData.dataItem);
        }
        setShowPopup(true);
    }

    const onClosePopup = () => {
        setShowPopup(false);
    }

    const handleDetailClick = (chartTitle) => {
        setOffice('');
        let title = chartTitle.replace('#', 'Number');
        setChartTitle(title);
        setxAxis(null);
        setyAxis(null);
        setShowPopup(true);
    };

    const renderForm = () => {
        return (
            <SystemPopup visible={true} popupTitle={popupTitle} popupWidth="1500px" onClose={onClosePopup} showCloseButton={false}>
                <SystemGridAndForm label="" grid={OpportunityChartDetail} data={{ PopupTitle: popupTitle, ChartTitle: chartTitle, XAxis: xAxis, YAxis: yAxis }} showAdd={false} />
            </SystemPopup>
        );
    };

    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title="Opportunity Chart" tagLine="" />
                <div className="container-fluid fieldsetGridAndForm mt-80">
                    <SystemPanel
                        toolbar={[<button key={Math.random()} className="btn btnSave me-2" onClick={() => { handleDetailClick('Opportunities by Workflow Stage') }} > Details by Stage</button>,
                        <button key={Math.random()} className="btn btnSave me-2" onClick={() => { handleDetailClick('Opportunities by Status') }} > Details by Status</button>]}
                        label="Dashboard" showAdd={false} showRefresh={false} showArchive={false}>
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="searchControlWrapper">
                                    <div className="col-md-3 col-12">
                                        <label className="col-md-4">Strategic Partner:</label>
                                        <input className="col-md-8" type="text" name="strategicPartner" onChange={(e) => { setStrategicPartner(e.target.value) }} style={{ border: '1px solid rgb(0, 0, 0)',borderRadius: 'inherit' }} />
                                    </div>
                                    <div className="col-md-3 col-12">
                                        <label className="col-md-4">Incumbent:</label>
                                        <input className="col-md-8" type="text" name="incumbent" onChange={(e) => { setIncumbent(e.target.value) }} style={{ border: '1px solid rgb(0, 0, 0)', borderRadius: 'inherit' }} />
                                    </div>
                                    <div className="col-md-1 col-12 buttonSubmit">
                                        <button onClick={(e) => { getGraphData() }} title="Apply Filter" className="btn btnSave">Apply Filter</button>
                                    </div>
                                </div>

                                <div className="searchControlWrapper flexCodes">
                                    <div className="searchControlBox searchControlBox50" style={{ paddingLeft: '15px', paddingRight: '15px' }} >
                                        <div className="formGroupContentWrapper" onClick={(e) => {
                                            setFilterOne(!filterOne);
                                        }}>
                                            <label>Location</label>
                                            <span className="spanIconBold"><span className="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterOne == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer location_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allLocation(true);
                                                        } else {
                                                            allLocation(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    locationsList && locationsList.length > 0 ?
                                                        locationsList.map((code, index) => {
                                                            if (code) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer location_check_boxes">
                                                                        <label className="normal-text"><input name={"location" + index} onChange={handleChange} type="checkbox" value={code.DataText} />
                                                                            &nbsp;{code.DataText}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="searchControlBox searchControlBox50" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                        <div className="formGroupContentWrapper" onClick={() => {
                                            setFilterTwo(!filterTwo);
                                        }}>
                                            <label>NAICS</label>
                                            <span className="spanIconBold"><span className="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterTwo == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer naics_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allNAICS(true);
                                                        } else {
                                                            allNAICS(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    NAICSList && NAICSList.length > 0 ?
                                                        NAICSList.map((code, index) => {
                                                            if (code) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer naics_check_boxes">
                                                                        <label className="normal-text"><input name={"naics" + index} onChange={handleChange} type="checkbox" value={code.DataText} />
                                                                            &nbsp;{code.DataText}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="searchControlBox searchControlBox50" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                        <div className="formGroupContentWrapper" onClick={() => {
                                            setFilterThree(!filterThree);
                                        }}>
                                            <label>Agency</label>
                                            <span className="spanIconBold"><span className="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterThree == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer location_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allAgency(true);
                                                        } else {
                                                            allAgency(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    agencyList && agencyList.length > 0 ?
                                                        agencyList.map((code, index) => {
                                                            if (code) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer agency_check_boxes">
                                                                        <label className="normal-text"><input name={"agency" + index} onChange={handleChange} type="checkbox" value={code.DataText} />
                                                                            &nbsp;{code.DataText}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="searchControlBox searchControlBox50" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                        <div className="formGroupContentWrapper" onClick={() => {
                                            setFilterFour(!filterFour);
                                        }}>
                                            <label>Workflow Stage</label>
                                            <span className="spanIconBold"><span className="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterFour == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer workflowstatus_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allWorkflowStatus(true);
                                                        } else {
                                                            allWorkflowStatus(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    workflowStageList && workflowStageList.length > 0 ?
                                                        workflowStageList.map((code, index) => {
                                                            if (code) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer workflowstatus_check_boxes">
                                                                        <label className="normal-text"><input name={"workflowstatus" + index} onChange={handleChange} type="checkbox" value={code.DataText} />
                                                                            &nbsp;{code.DataText}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="searchControlBox searchControlBox50" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                        <div className="formGroupContentWrapper" onClick={() => {
                                            setFilterFive(!filterFive);
                                        }}>
                                            <label>Opportunity Status</label>
                                            <span className="spanIconBold"><span className="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterFive == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer opportunitystatus_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allOpportunityStatus(true);
                                                        } else {
                                                            allOpportunityStatus(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    opportunityStatusList && opportunityStatusList.length > 0 ?
                                                        opportunityStatusList.map((code, index) => {
                                                            if (code) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer opportunitystatus_check_boxes">
                                                                        <label className="normal-text"><input name={"opportunitystatus" + index} onChange={handleChange} type="checkbox" value={code.DataText} />
                                                                            &nbsp;{code.DataText}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SystemPanel>
                </div>

                <div className="row">
                    <div className="col-md-12 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Total Accumulated Annual Contract Value by BD Office')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Total Accumulated Annual Contract Value by BD Office')}>
                                <ChartTitle text="Total Accumulated Annual Contract Value by BD Office ($mil)" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartValueAxis>
                                    <ChartValueAxisItem
                                        labels={{
                                            text: "c0"
                                        }}
                                    />
                                </ChartValueAxis>
                                <ChartSeries>
                                    {annualContractValueData.map((item, idx) =>
                                        <ChartSeriesItem
                                            key={idx}
                                            type="scatterLine"
                                            data={item.data}
                                            name={item.Year}
                                            xField="0"
                                            yField="1"
                                            tooltip={{
                                                visible: true,
                                                format: '${1:N2}'
                                            }} />
                                    )}
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-12 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('# of Wins by BD Office')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350, width: 1800 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, '# of Wins by BD Office')}>
                                <ChartTitle text="# of Wins by BD Office" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={categoriesForWins} />
                                </ChartCategoryAxis>
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="column"
                                        data={winsByBDOfficeData.map(item => item.Value)}
                                        tooltip={{ visible: true }} />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-12 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Contract Value vs Price to Win')}>Detail</button>
                            </div>
                            <Chart style={{ height: 1050, width:1800 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Contract Value vs Price to Win')}>
                                <ChartTitle text="Contract Value vs Price to Win" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={categoriesForContractPriceToWin} startAngle={45} labels={{ rotation: -45 }} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem
                                        labels={{
                                            format: "c0"
                                        }}
                                    />
                                </ChartValueAxis>
                                <ChartSeries>
                                    {contractValueVsPriceToWinData.map((item, idx) => (
                                        <ChartSeriesItem
                                            key={idx}
                                            type="column"
                                            tooltip={{
                                                visible: true,
                                                format: '${0:N2}'
                                            }}
                                            data={item.data}
                                            name={item.name}
                                        />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-6 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Total # of Active Opportunities')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Total # of Active Opportunities')}>
                                <ChartTitle text="Total # of Active Opportunities" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "roundedBevel" }}
                                        tooltip={{ visible: true }}
                                        data={activeOpportunitiesData}
                                        categoryField="Name"
                                        field="Value" />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-6 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Total Contract Value by BD Office')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Total Contract Value by BD Office')}>
                                <ChartTitle text="Total Contract Value by BD Office" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "roundedBevel" }}
                                        tooltip={{ visible: true, format: '${0:N2}' }}
                                        data={contractValueBDOfficeData}
                                        categoryField="Name"
                                        field="Value" />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-6 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Total Contract Value by NAICS')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350, width:895 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Total Contract Value by NAICS')}>
                                <ChartTitle text="Total Contract Value by NAICS" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "roundedBevel" }}
                                        tooltip={{ visible: true, format: '${0:N2}' }}
                                        data={contractValueNAICSData}
                                        categoryField="Name"
                                        field="Value" />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-6 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Total Contract Value by Agency')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Total Contract Value by Agency')}>
                                <ChartTitle text="Total Contract Value by Agency" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "roundedBevel" }}
                                        tooltip={{ visible: true, format: '${0:N2}' }}
                                        data={contractValueAgencyData}
                                        categoryField="Name"
                                        field="Value" />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-6 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Total Expense Budget by BD Office')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Total Expense Budget by BD Office')}>
                                <ChartTitle text="Total Expense Budget by BD Office" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "roundedBevel" }}
                                        tooltip={{ visible: true, format: '${0:N2}' }}
                                        data={totalExpenseBudgetData}
                                        categoryField="Name"
                                        field="Value" />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-6 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Number of Opportunities by Status')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Number of Opportunities by Status')}>
                                <ChartTitle text="Number of Opportunities by Status" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "roundedBevel" }}
                                        tooltip={{ visible: true }}
                                        data={opportunitiesByStatusData}
                                        categoryField="Name"
                                        field="Value" />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>

                    <div className="col-md-12 p-1">
                        <div className="k-card table-responsive">
                            <div className="chart-btn">
                                <button className="btn btn-primary" onClick={() => handleDetailClick('Proposals Due by Month')}>Detail</button>
                            </div>
                            <Chart style={{ height: 350, width:1800 }} onSeriesClick={(chartData) => handleOnChartValueClick(chartData, 'Proposals Due by Month')}>
                                <ChartTitle text="Proposals Due" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={categoriesProposalsDue} startAngle={45} />
                                </ChartCategoryAxis>
                                <ChartSeries>
                                    {proposalsDueData.map((item, idx) => (
                                        <ChartSeriesItem
                                            key={idx}
                                            type="column"
                                            tooltip={{ visible: true }}
                                            data={item.Value}
                                            name={item.Name} />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {showPopup && renderForm()}
    </>)
}

export default OpportunityChart;